import { FieldModel, ProgramBenchmarkName, ProgramTask, TaskDataTraitStatus } from '@cibo/core'
import { Stack, Typography } from '@mui/material'
import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import { TraitCellContainer } from './TraitCells/TraitCellContainer'
import { TRAIT_DISPLAY_MAP } from './traitDisplayMap'

interface TaskEditorTableCellProps extends GridRenderCellParams {
  row: { traitId: string; [key: string]: any }
  task: ProgramTask<{ benchmarkName: ProgramBenchmarkName; traits: TaskDataTraitStatus[] }>
  selectedField?: FieldModel
  onSaveSuccess?: () => void
}

export const TaskEditorTableCell = ({
  row: { traitId },
  value,
  field: year,
  task,
  selectedField,
  onSaveSuccess,
}: TaskEditorTableCellProps) => {
  const Display = TRAIT_DISPLAY_MAP[traitId]

  if (!Display) {
    return (
      <Stack>
        <Typography>{JSON.stringify(value)}</Typography>
      </Stack>
    )
  }

  return (
    <TraitCellContainer
      value={value}
      task={task}
      selectedField={selectedField}
      year={+year}
      traitId={traitId}
      onSaveSuccess={onSaveSuccess}
    >
      <Display value={value} />
    </TraitCellContainer>
  )
}
